import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ButtonAdd, File, HeadContainer, InputCol, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import lo from 'lodash';
import { TxtLink } from 'components/atoms/Texts/TxtLink';
import { SERVER_URL } from 'fixtures/api';
import Icon from 'atoms/Icon';
import ic_add from 'App/assets/images/ic_add.png'
import ic_doc from 'App/assets/images/ic-file-doc.png'
import ic_sheet from 'App/assets/images/ic-file-sheet.png'
import ic_pdf from 'App/assets/images/ic-file-pdf.png'
import ic_image from 'App/assets/images/ic-file-image.png'
import IconPng from 'components/atoms/IconPng/index';

const FILE_TYPES = {
  'png': ic_image,
  'jpg': ic_image,
  'doc': ic_doc,
  'docx': ic_doc,
  'xls': ic_sheet,
  'xlsx': ic_sheet,
  'pdf': ic_pdf,
}
export class ActualLoadingAttachmentsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachments: []
    }

  }

  componentDidUpdate(prevProps) {
    if (!lo.isEqual(this.props.form.attachments.length, prevProps.form.attachments.length) && !this.state.attachments.length){
      this.init();
    }
  }

  init() {
    // init state
    this.setState({ attachments: this.props.form.attachments })
  }
  fnChange(val) {
    const { onChange } = this.props
    const files = []
    for (var i = 0; i < val.length; i++) {
      const file = val[i]
      let reader = new FileReader()
      reader.addEventListener("load", (event) => {
        files.push({
          filename: file.name,
          mimeType: file.type,
          media: { type: ['png','jpg','jpeg'].indexOf(this.getExtension(file.name)) > -1 ? 'IMAGE' : 'DOCUMENT'},
          file: event.target.result.split(',')[1]
        })
        this.state.attachments.push(files[files.length - 1])
        this.setState({ attachments: this.state.attachments }, () => {
          onChange('attachments', this.state.attachments)
        })
      })
      reader.readAsDataURL(file)
    }
  }

  fnRemoveEvidence(file, index) {
    const { form, onChangeForm } = this.props
    if ( file.id ) {
      form['deleteAttachments'].push(file.id)
    }
    const newData = this.state.attachments.filter((d,i) => index !== i)
    this.setState({ attachments: newData }, () => {
      form['attachments'] = newData
      onChangeForm(form)
    })
  }

  getExtension(filename) {
    let arr = filename.split('.');
    let extension = arr.pop();
    return extension
  }

  render() {
    const { theme } = this.props
    return (
        <RoundedWrapper>
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Upload Document
              </Label>
            </HeadContainer>
              <LevelRowContainer>
              <InputCol>
                <Label lineheight={'14px'} size={'12px'}>
                  Attachments
                </Label>
                <div>
                  <div>
                    <ButtonAdd
                      src={ic_add}
                      onClick={() => document.getElementById('evidence').click()}
                    />
                  </div>
                  <input
                    id="evidence"
                    type="file"
                    accept={Object.keys(FILE_TYPES).join(',')}
                    onChange={e => this.fnChange(e.target.files)}
                    multiple
                    hidden
                  />
                  {
                    this.state.attachments.map((e, i) => (
                      !e.id ?
                      <File key={i}>
                        <IconPng srcIcon={FILE_TYPES[this.getExtension(e.filename)]} size={'auto'} h={'24'} mr={'20px'} />
                        <Label lineheight={'14px'} size={'12px'} mb="0">
                          {e.filename}
                        </Label>
                        <Icon
                          ml="auto"
                          name="times-circle"
                          color={theme.mocaRed}
                          onClick={() => this.fnRemoveEvidence(e, i)}
                          showPointer
                        />
                      </File>
                      :
                      <File key={i}>
                        <TxtLink
                          size={'12px'}
                          lineheight={'14px'}
                          weight={'400'}
                          color={theme.mocaGrey}
                          href={`${SERVER_URL}${e.media.contentUrl}`}
                          title={e.filename}
                          isNewTab
                        >
                          <IconPng srcIcon={FILE_TYPES[this.getExtension(e.filename)]} size={'auto'} h={'24'} mr={'20px'} />
                          <Label lineheight={'14px'} size={'12px'} mb="0">
                            {e.filename}
                          </Label>
                        </TxtLink>
                        <Icon
                          ml="auto"
                          name="times-circle"
                          color={theme.mocaRed}
                          onClick={() => this.fnRemoveEvidence(e, i)}
                          showPointer
                        />
                      </File>
                    ))
                  }
                </div>
              </InputCol>
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingAttachmentsForm)
  )
);